module.exports = __webpack_public_path__ + "img/character_wizard.e670f10a.svg";